import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const StyledSignInContainer = styled(Box)({
    marginTop: '8rem', // my: 8
    marginLeft: '4rem', // mx: 4
    marginRight: '4rem',
    marginBottom: '8rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
});
